import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CustomCarousel from "Root/profile/components/common/Carousel";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import styles from "./styles.module.css";
function ProductSection(props) {
    const { isCarousel } = props;
    const isTablet = useScreenWidth() < 999;
    const isMobile = useScreenWidth() < 600;
    const slidesToShow = props.products.length > 2 ? 2 : 1;
    return (_jsxs("div", { className: styles.container, children: [_jsx("h4", { className: `${styles.heading} ${props.personalized && styles.headingnarrow}`, children: props.title }), (isCarousel && isTablet && props.products.length > 2) || (isCarousel && isMobile) ? (_jsx("div", { className: styles.carouselwrapper, children: _jsx(CustomCarousel, { extraSettings: {
                        slidesToShow,
                        centerPadding: "-20px",
                        infinite: true,
                    }, arrowsRight: true, className: props.products.length > 2 ? styles.carouselwide : styles.carousel, minimumSlides: 1, children: props.products }) })) : (_jsx("div", { className: isCarousel && styles.blockwrapper, children: props.products.map((product, i) => (_jsx(React.Fragment, { children: _jsx("div", { className: `${styles.product_section_row} ${props.isCarousel ? styles.product_carousel_row : ""}`, children: product }) }, String(i)))) }))] }));
}
export default ProductSection;
